import { useEffect, useState } from "react";
import { Smartphone, CheckCircle2 } from "lucide-react";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function useInstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  const install = async () => { if (!prompt) return; prompt.prompt(); const r = await prompt.userChoice; if (r.outcome === "accepted") setPrompt(null); };
  return { canInstall: !!prompt && !installed, installed, install };
}

export function InstallButton({ className = "", compact = false }) {
  const { canInstall, installed, install } = useInstallPrompt();
  if (installed) return compact ? null : <span className={`inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 ${className}`} data-testid="install-done"><CheckCircle2 className="h-4 w-4" /> Terpasang</span>;
  if (!canInstall) return null;
  return (
    <button type="button" onClick={install} className={`inline-flex items-center gap-1.5 rounded-full bg-amber-500 hover:bg-amber-600 text-white text-xs font-bold px-3 py-1.5 shadow transition-colors ${className}`} data-testid="btn-install-app">
      <Smartphone className="h-4 w-4" /> Pasang di HP
    </button>
  );
}
